import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import type {
	FeaturesData,
	ServiceProjectFeature,
} from '@jira/router-resources__service-project-features/src/FeaturesData.types.tsx';
import type { FeatureStatus } from '@jira/servicedesk__common/src/Enabled.tsx';
import { useResource, type UseResourceHookResponse } from '@atlassian/react-resource-router';

const useServiceProjectFeatures = (): UseResourceHookResponse<Partial<
	Record<
		ServiceProjectFeature,
		{
			status: FeatureStatus;
			editable: boolean;
		}
	>
> | null> => useResource<FeaturesData | null>(featuresResource);

export default useServiceProjectFeatures;
